import { z } from 'zod';
import { FromSchema } from '@40seas/entities/common';

export const AddressMatchLocationSchema = z
    .object({
        lat: z.number(),
        lng: z.number(),
    })
    .strict();

export class AddressMatchLocation extends FromSchema(AddressMatchLocationSchema) {
    lat: number;
    lng: number;
}
